<template>
  <div class="page_container">
    <div class="top_header" v-if="!headerHidden">
      <div class="logo"></div>
      <div class="logo_title">极目新闻客户端</div>
      <a class="open_app" href="javascript:void(0)" @click="openApp()"></a>
      <a class="mob_jm_link" id="btnOpenApp" href="javascript:void(0)"></a>
    </div>
    <div :class="{'main_content':true,'allHeight':headerHidden}">
      <router-view @getMessage="showMsg"/>
    </div>
  </div>
</template>
<script>
import { getUrlParamObj } from "@/utils";
import jq from 'jquery';
import JMLink from "JMLink";
export default {
  name: "Layout",
  data() {
    return {
      jmLinkObj: null, //极光魔链
      headerHidden: false, // 是否隐藏顶部
      subPageParams:null,
      isShowContent:0, //开始加载时判断是否显示内容
      isGetMessage:false
    };
  },
  methods: {
    openApp() {
      var str = window.location.href;
      var query = getUrlParamObj(str);
      this.jmLinkObj.config.params = query;
      document.getElementById("btnOpenApp").click();
    },
    showMsg(msg,jgshareParams){ //获取子页面相关回传信息
      if(jgshareParams){
        this.subPageParams=jgshareParams;
      }
      if(msg===1){
        this.isShowContent=1;
        jq('body .init_mask').remove();
      }
      else{
        console.log('hello');
        jq('body').append('<div class="init_mask"></div>');
      }
      this.isGetMessage=true;
    },
  },
  watch: {
    '$route'(to, from) {
      if (to.path == from.path) {
        location.reload();
      }
    }
  },
  created() {
    let query = this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "client")) {
      if (query.client == 1 || query.client == '1' || query.client == true || query.client == 'true') {
        this.headerHidden = true;
      }
    }
  },
  mounted() {
    var str = window.location.href;
    var query = getUrlParamObj(str);
    if (!this.headerHidden) {
      this.jmLinkObj = new JMLink({
        jmlink: "https://b858ex.jglinks.cn/Aab8",
        button: document.querySelector("a#btnOpenApp"),
        autoLaunchApp: false,
        downloadWhenUniversalLinkFailed: true,
        inapp: true,
        params: query,
      });
    }
    setTimeout(() =>{
      if(!this.isGetMessage){
        this.isShowContent=1;
      }
    },50);
  }
};
</script>
<style lang="scss" scoped>
.page_container {
  width: 100%;
  height: 100%;
  .top_header {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    z-index: 9999;
    width: 100%;
    height: 12.4vw;
    background-color: #fff;
    outline: 1px solid #f0f0f0;
    .logo {
      float: left;
      width: 8.4vw;
      height: 8.4vw;
      background-image: url(~@/assets/images/logo/logo.png);
      background-repeat: no-repeat;
      background-position: center center;
      background-size: contain;
      margin-left: 3.6vw;
      margin-top: 2vw;
    }
    .logo_title {
      float: left;
      height: 5vw;
      line-height: 5vw;
      margin-left: 1.8vw;
      margin-top: 3.7vw;
      font-size: 4vw;
    }
    .open_app {
      float: right;
      width: 15vw;
      height: 6.2vw;
      margin-right: 3vw;
      margin-top: 3.1vw;
      background-image: url(~@/assets/images/btn_open.png);
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
    }
    .mob_jm_link {
      display: none;
    }
  }
  .main_content {
    position: relative;
    left: 0;
    top: 12.4vw;
    width: 100%;
    height: calc(100% - 12.4vw);
    &.allHeight {
      top: 0;
      height: 100%;
    }
  }
}
@media screen and (min-width: 750px) {
  .page_container {
    .top_header {
      height: 93px;
      .logo {
        width: 63px;
        height: 63px;
        margin-left: 27px;
        margin-top: 15px;
      }
      .logo_title {
        height: 37.5px;
        line-height: 37.5px;
        margin-left: 13.5px;
        margin-top: 27.75px;
        font-size: 28px;
      }
      .open_app {
        width: 112.5px;
        height: 46.5px;
        margin-right: 22.5px;
        margin-top: 23.25px;
      }
    }
    .main_content {
      top: 93px;
      height: calc(100% - 93px);
      &.allHeight {
        top: 0;
        height: 100%;
      }
    }
  }
}
</style>

<style>
.init_mask{
  display: block;
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background: #fff;
  z-index: 10000;
}
</style>